import { Dispatch, ReactChild, SetStateAction } from 'react';
import './modal.scss';

function Modal({ 
    open, 
    setOpen,
    id, 
    children,
    className
} : {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>,
    id?: string,
    children: ReactChild[] | ReactChild,
    className?: string;
}) {
    return (
        <div className={`modal ${open ? 'open' : ''} ${className}`} id={id} onClick={() => setOpen(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <i className="fal fa-times" onClick={() => setOpen(false)}></i>
                {children}
            </div>
        </div>
    )
}

export default Modal;